import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Reveal } from '../hooks/useReveal';
import { SectionTitle } from './About';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';

const FAQ = () => {
  const { t } = useLanguage();
  return (
    <section id="faq" className="section-pad bg-gradient-to-b from-[#14120d] via-[#1e1a11] to-[#14120d]">
      <div className="max-w-3xl mx-auto">
        <Reveal>
          <SectionTitle eyebrow={t.faq.eyebrow} title={t.faq.title} />
        </Reveal>
        <Reveal delay={120}>
          <Accordion type="single" collapsible className="mt-12 space-y-3">
            {t.faq.items.map((item, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="card-lux px-6 rounded-sm border-b"
              >
                <AccordionTrigger className="font-deco text-left text-lg text-[#f7f1e3] hover:text-[#f5deA0] hover:no-underline py-5">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="font-sans-el text-[15px] text-[#c2bbaa] font-light leading-relaxed pb-5">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};

export default FAQ;
